import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const ADD_NOTE_TAB_MUTATION = gql `
  mutation Admin_AddNoteTab($noteID: ID!, $data: EPNoteTabCreateInput!) {
    ep_addNoteTab(noteID: $noteID, data: $data) {
      id
      data {
        title
        content
        sequence
        version
      }
      ctime
      utime
      sequence
    }
  }
`;
export function useAddNoteTabMutation(options) {
    return useGQLMutation(ADD_NOTE_TAB_MUTATION, {
        ...options,
        update(cache, { data }, { variables }) {
            if (data?.ep_addNoteTab && variables) {
                cache.modify({
                    id: cache.identify({
                        __typename: 'EPNote',
                        id: variables.noteID,
                    }),
                    fields: {
                        tabs(existingTabs) {
                            const newTabRef = {
                                __ref: cache.identify({
                                    __typename: 'EPNoteTab',
                                    id: data.ep_addNoteTab.id,
                                }),
                            };
                            return [...existingTabs, newTabRef];
                        },
                    },
                });
            }
        },
    });
}
